class CustomProductTabs extends HTMLElement {
    constructor() {
        super();
        this.tabItems = this.querySelectorAll('.cstm-product-tabs__nav-item');
        this.tabContents = this.querySelectorAll('.cstm-product-tabs__content-item');
    }

    setEventListeners() {
        this.tabItems.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                this.tabItems.forEach((tab) => tab.classList.remove('active'));
                this.tabContents.forEach((tabContent) => tabContent.classList.remove('active'));
                tab.classList.add('active');
                this.tabContents[index].classList.add('active');
            });
        });
    }

    openFirstTab(){
        this.tabItems[0].click();
    }

    connectedCallback() {
        this.setEventListeners();
        this.openFirstTab();
    }

}
if (!customElements.get('cstm-product-tabs')) {
    customElements.define('cstm-product-tabs', CustomProductTabs);
}